// FNP-1191 — labels and basePath every navigate/link in the module references,
// so a route rename is one edit rather than a grep.
//
// ⚠️ `basePath` MUST stay '/zones': FNP-1186 registered `zones`,
// `zones/:zoneId` and `zones/:zoneId/records` in src/config/routes.tsx, and
// this ticket deliberately does not touch that file.
export default {
    entityKey: 'zones',
    basePath: '/zones',
    titles: {
        singular: 'Zone',
        plural: 'Zones',
    },
};
